<template>
	<div>
        <span v-if="!event">{{ placeholder }}</span>
        <icon-label v-else :icon="event.icon" :bkgColor="event.classShort" :value="event.label"></icon-label>
    </div>
</template>
<script>
    import IconLabel from './IconLabel.vue'

    export default {
        props : {
            value : {
                // unix timestamp
                type    : String,
                default : null,
            },
            placeholder : {
                default : '',
                required: false
            },
        },
        data() {
            return {
                list: [
                    {
                        event: 'email.sent',
                        label: this.$l10n.__('email envoyé'),
                        icon: 'icon-email-fillout',
                        class: 'primary-50-bkg white',
                        classShort: 'blue',
                    },
                    {
                        event: 'email.link.sent',
                        label: this.$l10n.__('email envoyé'),
                        icon: 'icon-email-fillout',
                        class: 'primary-50-bkg white',
                        classShort: 'blue',
                    },
                    {
                      event: 'emailengine.sent',
                      label: this.$l10n.__('email envoyé'),
                      icon: 'icon-email-fillout',
                      class: 'primary-50-bkg white',
                      classShort: 'blue',
                    },
                    {
                      event: 'email.scheduled.sent',
                      label: this.$l10n.__('email envoyé'),
                      icon: 'icon-email-fillout',
                      class: 'primary-50-bkg white',
                      classShort: 'blue',
                    },
                    {
                        event: 'email.scheduled.created',
                        label: this.$l10n.__('email programmé'),
                        icon: 'icon-email-fillout',
                        class: 'primary-50-bkg white',
                        classShort: 'blue',
                    },
                    {
                        event: 'calendar_event.created',
                        label: this.$l10n.__('événement passé'),
                        icon: 'icon-agenda-fillout',
                        class: 'red-bkg white',
                        classShort: 'red',
                    },
                    {
                        event: 'phonecall.created',
                        label: this.$l10n.__('appel passé'),
                        icon: 'icon-sellsyphone-fillout',
                        class: 'grey-bkg white',
                        classShort: 'grey',
                    },
                    {
                        event: 'task.completed',
                        label: this.$l10n.__('tâche terminée'),
                        icon: 'icon-task',
                        class: 'purple-bkg white',
                        classShort: 'purple',
                    }
                ]
            }
        },
        computed: {
            event() {
                return this.list.find((event) => event.event == this.value);
            }
        },
        components: {
            IconLabel
        }
    }
</script>
